"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ContractTreePanel;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const FilterableTable_1 = __importDefault(require("../../View/Resultsets/FilterableTable/FilterableTable"));
const TasksGlobalModalButtons_1 = require("../../TasksGlobal/Modals/TasksGlobalModalButtons");
const ScrumboardController_1 = require("../ScrumboardController");
const buildScrumTree_1 = require("./buildScrumTree");
const ScrumTaskRow_1 = __importDefault(require("./ScrumTaskRow"));
/** Prawy panel: drzewo wybranej umowy ENVI + kontraktów powiązanych, z filtrem osoby. */
function ContractTreePanel({ contract }) {
    const [data, setData] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [ownerId, setOwnerId] = (0, react_1.useState)(undefined);
    const [externalUpdate, setExternalUpdate] = (0, react_1.useState)(0);
    const employees = (0, react_1.useMemo)(() => MainSetupReact_1.default.personsEnviRepository?.items ?? [], []);
    (0, react_1.useEffect)(() => {
        if (!contract) {
            setData([]);
            return;
        }
        async function load() {
            setLoading(true);
            const orConditions = [{ contractId: contract.id, statusType: "active" }];
            if ("ourId" in contract) {
                orConditions.push({ ourIdRelated: contract.ourId, statusType: "active" });
            }
            const result = (await ScrumboardController_1.scrumContractsWithChildrenRepository.loadItemsFromServerPOST(orConditions, undefined, { skipCache: true }));
            setData(result);
            setOwnerId(undefined);
            setExternalUpdate((n) => n + 1);
            setLoading(false);
        }
        load();
    }, [contract]);
    const sections = (0, react_1.useMemo)(() => (0, buildScrumTree_1.buildScrumTree)(data, {
        ownerId,
        onlyInProgress: true,
        excludeBacklog: true,
        leavesRepository: ScrumboardController_1.scrumTasksRepository,
    }), [data, ownerId]);
    // Selektor osoby renderowany w wierszu nagłówka FilterableTable (obok "Zadania" i przycisku zwiń)
    const PersonFilterControl = (0, react_1.useMemo)(() => {
        const Control = () => (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mb-0 small text-muted" }, "Filtruj zadania osoby:"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { size: "sm", style: { width: "auto" }, value: ownerId ?? "", onChange: (e) => {
                    setOwnerId(e.target.value ? Number(e.target.value) : undefined);
                    setExternalUpdate((n) => n + 1);
                } },
                react_1.default.createElement("option", { value: "" }, "Wszyscy"),
                employees.map((p) => (react_1.default.createElement("option", { key: p.id, value: p.id },
                    p.name,
                    " ",
                    p.surname))))));
        return Control;
    }, [ownerId, employees]);
    if (!contract) {
        return (react_1.default.createElement("div", { className: "text-muted p-3" },
            react_1.default.createElement("h5", null, "Wybierz umow\u0119 z listy po lewej"),
            react_1.default.createElement("p", null, "Zobaczysz kontrakt ENVI oraz powi\u0105zane kontrakty na roboty i dostawy.")));
    }
    if (loading)
        return react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null);
    return (react_1.default.createElement(FilterableTable_1.default, { id: `scrumTasks_${contract.id}`, title: "Zadania", showTableHeader: false, repository: ScrumboardController_1.scrumTasksRepository, AddNewButtonComponents: [PersonFilterControl], EditButtonComponent: TasksGlobalModalButtons_1.TaskEditModalButton, initialSections: sections, snapshotMode: "criteria-only", externalUpdate: externalUpdate, tableStructure: [
            {
                header: "Zadania",
                renderTdBody: (task, isActive) => (react_1.default.createElement(ScrumTaskRow_1.default, { task: task, isActive: isActive })),
                colLg: 11,
            },
        ] }));
}
